// Backend-backed flow store with a small in-memory cache so existing
// synchronous, event-driven callers (FlowChart / Guru) keep working.
// Flows are company-scoped and persisted via the API so technicians can run
// them on mobile. localStorage only remembers the "last opened" flow id.
import { flowsApi } from "./api";

const ACTIVE_KEY = "servicepro_active_flow_v3";

let _cache = [];
let _loaded = false;
let _loading = null;

function emit() {
  window.dispatchEvent(new Event("flows-changed"));
}

export async function loadFlows() {
  if (_loading) return _loading;
  _loading = flowsApi
    .list()
    .then((list) => {
      _cache = Array.isArray(list) ? list : [];
      _loaded = true;
      emit();
      return _cache;
    })
    .catch(() => _cache)
    .finally(() => {
      _loading = null;
    });
  return _loading;
}

// Synchronous read of the cache. Triggers a background refresh on first use.
export function listFlows() {
  if (!_loaded && !_loading) loadFlows();
  return _cache;
}

export function getFlow(id) {
  return _cache.find((f) => f.id === id) || null;
}

export function getActiveId() {
  const id = localStorage.getItem(ACTIVE_KEY);
  if (id && _cache.some((f) => f.id === id)) return id;
  return _cache[0]?.id || null;
}

export function setActiveId(id) {
  if (id) localStorage.setItem(ACTIVE_KEY, id);
  window.dispatchEvent(new Event("active-flow-changed"));
}

function _body(payload) {
  return {
    name: payload.name || "Untitled Flow",
    nodes: payload.nodes || [],
    edges: payload.edges || [],
    trade: payload.trade || "",
    subCategory: payload.subCategory || "",
    priority: payload.priority || "",
    mandatory: !!payload.mandatory,
    purpose: payload.purpose || "diagnostic",
    equipmentType: payload.equipmentType || "",
    symptomKeywords: payload.symptomKeywords || [],
  };
}

// Create (no id) or update (with id). Returns the saved flow.
export async function saveFlow(payload) {
  const saved = payload.id
    ? await flowsApi.update(payload.id, _body(payload))
    : await flowsApi.create(_body(payload));
  await loadFlows();
  setActiveId(saved.id);
  return saved;
}

export async function deleteFlow(id) {
  await flowsApi.remove(id);
  await loadFlows();
  if (getActiveId() === id) setActiveId(_cache[0]?.id || null);
  return _cache;
}

export async function newBlankFlow(name = "New Flow") {
  return saveFlow({
    name,
    nodes: [{ id: "n1", type: "startNode", position: { x: 280, y: 80 }, data: { label: "Start", description: "" } }],
    edges: [],
  });
}
